import React from "react";
import { object } from "prop-types";
import { useDispatch } from "react-redux";
import { Link, ResponsiveImage } from "@quintype/components";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { SvgIconHandler } from "../../atoms";
import CircleIcon from "../../atoms/Circle";

import { UserFallbackIcon } from "../../../arrow/components/Svgs/user-fallback-icon";
import { getCategoryAndSubCategory } from "../../../ga-utils";
import { getTemplateName } from "../../../components/utils";
import { navigateTo } from "../../../arrow/utils/utils";
import "./ranking-entities.m.css";

const authorImage = (author) => {
  const deviceType = useDeviceType();
  const desktop = deviceType === "desktop";
  const widthAndHeight = desktop ? 135 : 96;
  const { "avatar-url": avatarUrl, "avatar-s3-key": avatarS3Key, name: authorName } = author;
  return (
    <>
      {avatarS3Key ? (
        <ResponsiveImage
          slug={avatarS3Key}
          aspect-ratio={[1, 1]}
          defaultWidth={80}
          imgParams={{ auto: ["format", "compress"], q: 70 }}
          alt={authorName}
          shouldDecodeImage={true}
        />
      ) : avatarUrl ? (
        <img src={`${avatarUrl}?q=70`} alt={authorName} />
      ) : (
        <UserFallbackIcon />
      )}
    </>
  );
};

const AuthorCard = ({ handleStoryClick, ...author }) => {
  const { name, slug, metadata = {} } = author;
  return (
    <div onClick={() => handleStoryClick()}>
      <Link href={`/author/${slug}`} disableAjaxLinks={true}>
        <div styleName="card-container">
          <div styleName="content">
            <div styleName="logo">{authorImage(author)}</div>
            <div styleName="name">{name}</div>
            <div styleName="year">{metadata.designation || ""}</div>
          </div>
        </div>
      </Link>
    </div>
  );
};

const KeyAuthors = ({ collection }) => {
  const dispatch = useDispatch();

  const pushDataLayerEvent = (position) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, "home-page");
      window.dataLayer.push({
        event: "dl_story_listing_component_click",
        link_position: position,
        section_name: collection?.name?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName("home-page"),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const handleCollectionNameClick = () => {
    pushDataLayerEvent(-2);
    navigateTo(dispatch, "/author");
  };

  const handleReadMoreClick = () => {
    pushDataLayerEvent(-1);
    navigateTo(dispatch, "/author");
  };

  const handleStoryClick = (position) => () => {
    pushDataLayerEvent(position + 1); // +1 to convert from 0-indexed to 1-indexed
  };

  const deviceType = useDeviceType();
  const itemToShow = deviceType === "desktop" ? 5 : 6;
  return (
    <div styleName="entity-container">
      <div styleName="header-row">
        <div styleName="title-link" onClick={() => handleCollectionNameClick()}>
          <CircleIcon />
          <span styleName="title">{collection?.name}</span>
        </div>
        <div styleName="read-more-link" onClick={() => handleReadMoreClick()}>
          {deviceType === "desktop" && "Read More"}
          <SvgIconHandler type="read-more-arrow" width="18" height="18" viewBox="0 0 24 24" />
        </div>
      </div>
      <div styleName="entity-list">
        {collection?.authors.slice(0, itemToShow).map((author, index) => (
          <AuthorCard key={author.id || index} {...author} handleStoryClick={handleStoryClick(index)} />
        ))}
      </div>
    </div>
  );
};

KeyAuthors.propTypes = {
  collection: object.isRequired,
};

export default KeyAuthors;
